(function(){
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var esc = function(s){ return String(s).replace(/[&<>\"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  /* On phones a tap goes straight to the product page — no quick-view step. */
  var isPhone = function(){ return window.matchMedia("(max-width: 760px)").matches; };

  function group(n, sep){ return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + sep); }
  function fmt(cents){
    var f = (window.YZY && YZY.money) || "${{amount}}";
    var v = (cents/100).toFixed(2);
    var whole = v.split(".")[0], dec = v.split(".")[1];
    return f
      .replace(/\{\{\s*amount\s*\}\}/g, group(whole, ",") + "." + dec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(String(Math.round(cents/100)), ","))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(whole, ".") + "," + dec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(String(Math.round(cents/100)), "."))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, group(whole, "'") + "." + dec);
  }

  var scrim = $("#yzyScrim"), menu = $("#yzyMenu"), cart = $("#yzyCart"), pdp = $("#yzyPdp"), burger = $("#yzyBurger");
  var grid = $("#yzyGrid"), cats = $("#yzyCats");
  var shopScroll = 0;

  function resetGrid(){ if (!grid) return; grid.classList.remove("zooming"); grid.style.transform = ""; }
  function closeAll(){
    [menu, cart].forEach(function(d){ if(d) d.classList.remove("on"); });
    if (pdp) pdp.classList.remove("on");
    if (scrim) scrim.classList.remove("on");
    if (burger) burger.setAttribute("aria-expanded","false");
    document.body.style.overflow = "";
    resetGrid();
  }
  function backToShop(){ closeAll(); window.scrollTo(0, shopScroll); }
  function open(d){ closeAll(); if(!d) return; d.classList.add("on"); if(scrim) scrim.classList.add("on"); if(d===menu&&burger) burger.setAttribute("aria-expanded","true"); }
  if (burger) burger.addEventListener("click", function(){ menu.classList.contains("on") ? closeAll() : open(menu); });
  var cartBtn = $("#yzyCartBtn"); if (cartBtn) cartBtn.addEventListener("click", function(e){ e.preventDefault(); open(cart); refreshCart(); });
  if (scrim) scrim.addEventListener("click", closeAll);
  document.addEventListener("click", function(e){ if (e.target.closest("[data-yzy-close]")) closeAll(); });
  var backBtn = $("#yzyPdpBack"); if (backBtn) backBtn.addEventListener("click", backToShop);
  document.addEventListener("keydown", function(e){
    if (e.key !== "Escape") return;
    (pdp && pdp.classList.contains("on")) ? backToShop() : closeAll();
  });

  if (cats && grid) cats.addEventListener("click", function(e){
    var b = e.target.closest("button[data-cat]"); if (!b) return;
    var c = b.dataset.cat;
    cats.querySelectorAll("button").forEach(function(x){ x.setAttribute("aria-pressed", x.dataset.cat === c); });
    grid.querySelectorAll(".tile").forEach(function(t){
      t.hidden = !(c === "ALL" || (" " + t.dataset.cats + " ").indexOf(" " + c + " ") > -1);
    });
  });

  var steps = [2,3,4,5], step = steps.indexOf(parseInt((grid && grid.dataset.cols) || 4, 10));
  if (step < 0) step = 2;
  var label = $("#yzyCols"), zOut = $("#yzyZoomOut"), zIn = $("#yzyZoomIn");
  function setCols(){
    if (!grid) return;
    grid.style.setProperty("--cols", steps[step]);
    if (label) label.textContent = steps[step];
    if (zOut) zOut.disabled = step === 0;
    if (zIn) zIn.disabled = step === steps.length - 1;
  }
  if (zOut) zOut.addEventListener("click", function(){ if (step > 0){ step--; setCols(); } });
  if (zIn) zIn.addEventListener("click", function(){ if (step < steps.length-1){ step++; setCols(); } });
  setCols();

  var current = null, variantId = null;
  if (grid) grid.addEventListener("click", function(e){
    var a = e.target.closest("a[data-handle]"); if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (isPhone()) return; /* follow the link to the full product page */
    e.preventDefault();
    shopScroll = window.scrollY;
    var load = fetch("/products/" + a.dataset.handle + ".js").then(function(r){ return r.json(); });
    if (reduce) { load.then(showPdp).catch(function(){ window.location = a.href; }); return; }
    var r = a.getBoundingClientRect();
    var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
    var scale = Math.min(2.6, Math.max(1.6, window.innerWidth / (r.width * 2.4)));
    grid.style.transformOrigin = (r.left + r.width/2 + window.scrollX) + "px " + (r.top + r.height/2 + window.scrollY) + "px";
    grid.style.transform = "translate(" + (cx - (r.left + r.width/2)) + "px, " + (cy - (r.top + r.height/2)) + "px) scale(" + scale + ")";
    grid.classList.add("zooming");
    Promise.all([load, new Promise(function(res){ setTimeout(res, 340); })])
      .then(function(v){ showPdp(v[0]); })
      .catch(function(){ window.location = a.href; });
  });

  function shipCopy(){ var t = $("#yzyShipCopy"); return t ? t.innerHTML : ""; }
  function setMsg(text){
    var el = $("#yzyAddMsg");
    if (el) { el.textContent = text || ""; el.style.display = text ? "block" : "none"; }
  }
  function showPdp(p){
    current = p;
    var first = p.variants.filter(function(v){ return v.available; })[0];
    variantId = first ? first.id : null;
    $("#yzyPdpTitle").textContent = p.title;
    $("#yzyPdpPrice").innerHTML = esc(fmt(p.price)) + (p.compare_at_price > p.price ? ' <s style="color:var(--mute)">' + esc(fmt(p.compare_at_price)) + '</s>' : '') + (p.available ? "" : " — Sold out");
    $("#yzyPdpLink").href = "/products/" + p.handle;
    $("#yzyPdpSizeLbl").textContent = p.variants.length > 1 ? "Size" : "Availability";
    $("#yzyPdpShots").innerHTML = (p.images.length ? p.images : []).slice(0,6).map(function(src,i){
      return '<figure><img src="' + src + '" alt="' + esc(p.title) + ' view ' + (i+1) + '" loading="lazy"></figure>';
    }).join("");
    var acc = '<details open><summary>Description</summary><div class="body">' + (p.description || "") + "</div></details>";
    if (p.type) acc += '<details><summary>Specification</summary><div class="body"><p>' + esc(p.type) + "</p></div></details>";
    var ship = shipCopy();
    if (ship) acc += '<details><summary>Shipping &amp; return</summary><div class="body">' + ship + "</div></details>";
    $("#yzyPdpAcc").innerHTML = acc;
    setMsg("");
    drawSizes();
    closeAll();
    pdp.classList.add("on");
    pdp.scrollTop = 0;
    document.body.style.overflow = "hidden";
  }
  function drawSizes(){
    $("#yzyPdpSizes").innerHTML = current.variants.map(function(v){
      return '<button type="button" data-vid="' + v.id + '"' + (v.available ? "" : " disabled") + ' aria-pressed="' + (v.id === variantId) + '">' + esc(v.title) + "</button>";
    }).join("");
    var add = $("#yzyAdd");
    add.disabled = !variantId;
    add.textContent = variantId ? "Add to cart" : "Sold out";
  }
  var sizesEl = $("#yzyPdpSizes");
  if (sizesEl) sizesEl.addEventListener("click", function(e){
    var b = e.target.closest("button[data-vid]"); if (!b || b.disabled) return;
    variantId = parseInt(b.dataset.vid, 10); setMsg(""); drawSizes();
  });

  var addBtn = $("#yzyAdd");
  if (addBtn) addBtn.addEventListener("click", function(){
    if (!variantId) return;
    addBtn.disabled = true;
    addBtn.textContent = "Adding…";
    fetch("/cart/add.js", { method:"POST", headers:{"Content-Type":"application/json", "Accept":"application/json"}, body: JSON.stringify({ items:[{ id: variantId, quantity: 1 }] }) })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, body: j }; }); })
      .then(function(res){
        addBtn.disabled = false;
        addBtn.textContent = "Add to cart";
        if (!res.ok) { setMsg(res.body.description || res.body.message || "That item could not be added."); return; }
        setMsg("");
        open(cart);
        return refreshCart();
      })
      .catch(function(){
        addBtn.disabled = false;
        addBtn.textContent = "Add to cart";
        setMsg("Something went wrong. Please try again.");
      });
  });

  function changeLine(key, qty){
    return fetch("/cart/change.js", { method:"POST", headers:{"Content-Type":"application/json", "Accept":"application/json"}, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(refreshCart);
  }
  function refreshCart(){
    return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll("[data-cart-count]").forEach(function(el){ el.textContent = c.item_count; });
      var lines = $("#yzyCartLines");
      if (lines) {
        lines.innerHTML = c.items.length ? c.items.map(function(l){
          var variant = (l.variant_title && l.variant_title !== "Default Title") ? esc(l.variant_title) + " &middot; " : "";
          return '<div class="line cap"><a href="' + l.url + '"><img src="' + (l.image || "") + '" alt=""></a>' +
            '<div><a class="name" style="font-size:11px" href="' + l.url + '">' + esc(l.product_title) + "</a>" +
            '<div style="color:var(--mute);margin-top:5px">' + variant + fmt(l.price) + "</div>" +
            '<div style="display:flex;align-items:center;gap:10px;margin-top:8px">' +
              '<button type="button" data-q="' + l.key + '|' + (l.quantity - 1) + '" aria-label="Decrease quantity" style="width:22px;height:22px;border:1px solid #ddd">&minus;</button>' +
              '<span class="num">' + l.quantity + "</span>" +
              '<button type="button" data-q="' + l.key + '|' + (l.quantity + 1) + '" aria-label="Increase quantity" style="width:22px;height:22px;border:1px solid #ddd">+</button>' +
            "</div></div>" +
            '<button type="button" class="rm" data-key="' + l.key + '">Remove</button></div>';
        }).join("") : '<p class="empty cap">Cart is empty</p>';
      }
      var sub = $("#yzySubtotal"); if (sub) sub.textContent = fmt(c.total_price);
    });
  }
  var linesEl = $("#yzyCartLines");
  if (linesEl) linesEl.addEventListener("click", function(e){
    var q = e.target.closest("[data-q]");
    if (q) {
      var bits = q.dataset.q.split("|");
      changeLine(bits[0], Math.max(0, parseInt(bits[1], 10)));
      return;
    }
    var b = e.target.closest("[data-key]");
    if (b) changeLine(b.dataset.key, 0);
  });
  refreshCart();
})();
